import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useImportCancelConfirmModal = () => {
  const { t } = useTranslation();

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('import_export_history_cancel_confirm_title'),
      body: t('import_export_history_cancel_confirm_message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t('cancel'),
        size: 'sm',
      },
      okButtonProps: {
        color: 'danger',
        isSecondary: true,
        children: t('import_export_history_cancel'),
        size: 'sm',
      },
    }),
    [t]
  );

  return useConfirmModal(args);
};
